<script>
  export let interactive = false
  export let prefix = false
  export let suffix = false
  export let circle = false

  /** @type {('left'|'right')?}*/
  export let rotate = null

  /** @type {string?} */
  export let name = null

  /** @type {null|'xs'|'sm'|'md'|'lg'|'xl'|'xxl'|'fill'}*/
  export let size = null

  export let adapt = false
</script>

<svg
  class="symbol"
  class:clickthrough={!interactive}
  class:prefix
  class:suffix
  class:circle
  class:adapt
  class:left={rotate === 'left'}
  class:right={rotate === 'right'}
  class:xs={size === 'xs'}
  class:sm={size === 'sm'}
  class:md={size === 'md'}
  class:lg={size === 'lg'}
  class:xl={size === 'xl'}
  class:xxl={size === 'xxl'}
  class:fill={size === 'fill'}
  width="24"
  height="24"
  role="presentation"
  viewBox="0 0 24 24">
  <g fill="currentColor" fill-rule="evenodd">
    <slot>
      {#if name === 'clock'}
        <path
          fill="currentColor"
          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-.22-13h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l4.15 2.49c.34.2.78.1.98-.24.21-.34.1-.79-.25-.99l-3.87-2.3V7.72c0-.4-.32-.72-.72-.72z" />
      {/if}
      {#if name === 'pin'}
        <path
          fill="currentColor"
          d="M12.381 1c4.6286 0 8.3809 3.7523 8.3809 8.381 0 2.91-2.4846 7.1132-7.4537 12.6093a1.25 1.25 0 01-.089.089c-.512.463-1.3025.4232-1.7655-.089l-.335-.3727C6.373 16.3038 4 12.2249 4 9.381 4 4.7523 7.7523 1 12.381 1zm0 5c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3c1.6568 0 3-1.3431 3-3s-1.3432-3-3-3z" />
      {/if}
      {#if name === 'trash'}
        <path
          d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z" />
      {/if}
      {#if name === 'pencil'}
        <path
          d="M4 16.9v2.7c0 .2.2.4.4.4h2.7l.3-.1 9.6-9.6L13.7 7l-9.6 9.6-.1.3zm15.8-9.5c.3-.3.3-.8 0-1.2l-2-2a.8.8 0 00-1.2 0L15 5.8 18.2 9l1.6-1.6z" />
      {/if}
      {#if name === 'people'}
        <path
          fill="currentColor"
          d="M10.0078 13.4206C8.50077 14.7305 7.32701 16.7566 7.32701 18.2746C7.32701 18.7517 7.42467 19.2136 7.65357 19.6156H1.7234C0.462764 19.6156 0 19.0697 0 18.1192C0 15.7085 2.65428 12.7546 6.6588 12.7546C8.13008 12.7546 8.96796 12.7951 10.0078 13.4206ZM9.85467 8.26808C9.85467 10.2324 8.39825 11.7724 6.66496 11.7724C4.92838 11.7724 3.47198 10.2354 3.47198 8.28348C3.47198 6.36636 4.94028 4.84846 6.66496 4.84846C8.38632 4.84846 9.85467 6.33577 9.85467 8.26808Z" />
        <path
          fill="currentColor"
          d="M16.3549 11.9564C18.3557 11.9564 20.0197 10.1948 20.0197 7.92979C20.0197 5.72056 18.341 4 16.3549 4C14.3689 4 12.6931 5.74518 12.6931 7.94497C12.6931 10.1948 14.3571 11.9564 16.3549 11.9564ZM10.7554 19.6128H21.9513C23.4774 19.6128 24 19.132 24 18.2746C24 15.9575 21.0331 12.7788 16.3488 12.7788C11.6735 12.7788 8.70379 15.9575 8.70379 18.2746C8.70379 19.132 9.22644 19.6128 10.7554 19.6128Z" />
      {/if}
      {#if name === 'person'}
        <path
          fill="currentColor"
          d="M4.18278 22.2715H19.6815C21.0472 22.2715 21.8605 21.6185 21.8605 20.5341C21.8605 17.5255 18.0083 13.3984 11.9263 13.3984C5.85596 13.3984 2 17.5255 2 20.5341C2 21.6185 2.81708 22.2715 4.18278 22.2715ZM11.9343 12.3305C14.5241 12.3305 16.6926 10.0433 16.6926 7.10241C16.6926 4.23397 14.5129 2 11.9343 2C9.35565 2 7.17969 4.26594 7.17969 7.12212C7.17969 10.0433 9.3402 12.3305 11.9343 12.3305Z" />
      {/if}
      {#if name === 'calendar'}
        <path
          d="M19.778 2.2h-1.111V1.1c0-.605-.5-1.1-1.111-1.1-.612 0-1.112.495-1.112 1.1v1.1H7.556V1.1c0-.605-.5-1.1-1.112-1.1-.61 0-1.11.495-1.11 1.1v1.1H4.221c-1.233 0-2.21.99-2.21 2.2L2 19.8c0 1.21.989 2.2 2.222 2.2h15.556C21 22 22 21.01 22 19.8V4.4c0-1.21-1-2.2-2.222-2.2zm-1.111 17.6H5.333a1.109 1.109 0 01-1.11-1.1v-11h15.555v11c0 .605-.5 1.1-1.111 1.1zM7.556 9.9h3.333C11.5 9.9 12 10.395 12 11v3.3c0 .605-.5 1.1-1.111 1.1H7.556a1.109 1.109 0 01-1.112-1.1V11c0-.605.5-1.1 1.112-1.1z" />
      {/if}
      {#if name === 'magnifier'}
        <path
          d="M0 9.53718C0 14.801 4.27757 19.0765 9.53929 19.0765C11.4961 19.0765 13.2919 18.4751 14.7891 17.46L20.1729 22.8534C20.5099 23.1905 20.9564 23.351 21.4263 23.351C22.4236 23.351 23.1368 22.5973 23.1368 21.6117C23.1368 21.1481 22.9666 20.7155 22.6446 20.3935L17.3022 15.0202C18.4207 13.4815 19.0786 11.5898 19.0786 9.53718C19.0786 4.27547 14.801 0 9.53929 0C4.27757 0 0 4.27547 0 9.53718ZM2.48482 9.53718C2.48482 5.64491 5.64702 2.48482 9.53929 2.48482C13.4316 2.48482 16.5916 5.64491 16.5916 9.53718C16.5916 13.4316 13.4316 16.5916 9.53929 16.5916C5.64702 16.5916 2.48482 13.4316 2.48482 9.53718Z" />
      {/if}
      {#if name === 'checkmark'}
        <path
          d="M9.4 15.3l-3-3a1.4 1.4 0 10-2 2l4 4c.6.6 1.5.6 2 0l10.2-10a1.4 1.4 0 10-2-2.1l-9.2 9.1z" />
      {/if}
      {#if name === 'arrow'}
        <path
          d="M5 13h11.17l-4.88 4.88a1 1 0 000 1.42 1 1 0 001.41 0l6.59-6.59a1 1 0 000-1.41l-6.58-6.6a1 1 0 10-1.41 1.41L16.17 11H5a1 1 0 00-1 1 1 1 0 001 1z" />
      {/if}
      {#if name === 'question'}
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          d="M11 12.8c.8-1.3 2.3-2.2 3.2-3.4.9-1.3.4-3.7-2.2-3.7C10.3 5.7 9.5 7 9.1 8L6.5 7c.8-2.2 2.7-4 5.5-4 2.3 0 4 1 4.8 2.4.7 1.2 1 3.3 0 5-1.2 1.7-2.4 2.2-3 3.4-.2.4-.3.7-.3 2.2h-3c0-.8 0-2 .6-3.2zm3 7.2c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z" />
      {/if}
      {#if name === 'cross'}
        {#if size === 'sm'}
          <path
            d="M18.45 5.57a1.5 1.5 0 00-2.11 0L12 9.88 7.67 5.55a1.5 1.5 0 10-2.12 2.12L9.88 12l-4.33 4.34a1.5 1.5 0 102.12 2.11L12 14.12l4.34 4.33a1.5 1.5 0 102.11-2.11L14.12 12l4.33-4.33a1.5 1.5 0 000-2.1z" />
        {:else}
          <path
            d="M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
        {/if}
      {/if}
      {#if name === 'plus'}
        {#if size === 'sm'}
          <path
            d="M18 13.5h-4.5V18c0 .82-.68 1.5-1.5 1.5a1.5 1.5 0 01-1.5-1.5v-4.5H6A1.5 1.5 0 014.5 12c0-.82.67-1.5 1.5-1.5h4.5V6c0-.83.68-1.5 1.5-1.5s1.5.67 1.5 1.5v4.5H18c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5z" />
        {:else}
          <path
            d="M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z" />
        {/if}
      {/if}
      {#if name === 'minus'}
        <path
          d="M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z" />
      {/if}
      {#if name === 'chevron'}
        {#if size === 'sm'}
          <path
            d="M7.61 8.42l4.4 4.12 4.4-4.12a1.6 1.6 0 012.14 0c.6.56.6 1.46 0 2.02l-5.47 5.14a1.6 1.6 0 01-2.16 0l-5.47-5.14c-.6-.56-.6-1.46 0-2.02.6-.55 1.57-.56 2.16 0z" />
        {:else}
          <path
            d="M8.12 9.29L12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 010-1.41c.39-.38 1.03-.39 1.42 0z" />
        {/if}
      {/if}
      {#if name === 'bed'}
        <path
          d="M8 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 8h-5c-1 0-1.8.7-1.8 1.6V14H4.5V7.1c0-.5-.3-.9-.8-.9s-.9.4-.9.9v11c0 .5.4.9.9.9s.8-.4.8-.9v-1.7H20v1.7c0 .5.3.9.8.9s.8-.4.8-.9v-6.8C21.5 9.5 20 8 18.1 8z" />
      {/if}
      {#if name === 'share'}
        <path
          d="M11.6.1L9 3c-.4.3-.1.9.3.9H11v9c0 .5.4 1 1 1 .5 0 1-.5 1-1v-9h1.8c.4 0 .7-.5.3-.9L12.3.2a.5.5 0 00-.7 0zM20 6h-4a1 1 0 00-1 1c0 .5.4 1 1 1h3c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1H5a1 1 0 01-1-1V9c0-.6.5-1 1-1h3a1 1 0 000-2H4a2 2 0 00-2 2v11c0 1.1.9 2 2 2h16a2 2 0 002-2V8a2 2 0 00-2-2z" />
      {/if}
      {#if name === 'link'}
        <path
          d="M12 4.92892L9.87868 7.05024C9.48978 7.43915 9.48978 8.07555 9.87868 8.46445C10.2676 8.85336 10.904 8.85336 11.2929 8.46445L13.4142 6.34313C14.5809 5.17641 16.4901 5.17641 17.6569 6.34313C18.8236 7.50986 18.8236 9.41905 17.6569 10.5858L15.5355 12.7071C15.1466 13.096 15.1466 13.7324 15.5355 14.1213C15.9244 14.5102 16.5608 14.5102 16.9498 14.1213L19.0711 12C21.0227 10.0484 21.0227 6.88054 19.0711 4.92892C17.1195 2.97731 13.9516 2.97731 12 4.92892ZM9.17158 14.8284C9.56049 15.2173 10.1969 15.2173 10.5858 14.8284L14.8284 10.5858C15.2173 10.1969 15.2173 9.56047 14.8284 9.17156C14.4395 8.78265 13.8031 8.78265 13.4142 9.17156L9.17158 13.4142C8.78267 13.8031 8.78267 14.4395 9.17158 14.8284ZM12.7071 15.5355L10.5858 17.6568C9.41906 18.8236 7.50988 18.8236 6.34315 17.6568C5.17642 16.4901 5.17642 14.5809 6.34315 13.4142L8.46447 11.2929C8.85338 10.904 8.85338 10.2676 8.46447 9.87867C8.07556 9.48976 7.43917 9.48976 7.05026 9.87867L4.92894 12C2.97732 13.9516 2.97732 17.1194 4.92894 19.0711C6.88055 21.0227 10.0484 21.0227 12 19.0711L14.1213 16.9497C14.5102 16.5608 14.5102 15.9244 14.1213 15.5355C13.7324 15.1466 13.096 15.1466 12.7071 15.5355Z" />
      {/if}
      {#if name === 'ticket'}
        <path
          fill="currentColor"
          d="M19.0103 12.5329L11.0755 20.4679C9.08471 22.4693 6.40995 22.2894 4.6986 20.5565C2.97312 18.8452 2.79662 16.1885 4.79074 14.1871L15.6753 3.30984C16.8235 2.16501 18.5442 1.92518 19.6797 3.05681C20.8147 4.20649 20.5715 5.91298 19.4306 7.06122L8.7245 17.7775C8.2876 18.2256 7.76342 18.0955 7.46353 17.7989C7.17047 17.4951 7.04759 16.9856 7.48108 16.5341L14.9479 9.08532C15.3583 8.66413 15.3764 8.05575 14.9766 7.65941C14.5803 7.27381 13.9685 7.28844 13.558 7.69891L6.06639 15.1906C4.87682 16.3801 4.92995 18.2171 5.9874 19.2712C7.13748 20.4213 8.87503 20.3965 10.0719 19.1995L20.8346 8.43691C22.9563 6.31514 22.891 3.5162 21.0164 1.64163C19.1847 -0.186626 16.3394 -0.298286 14.2177 1.82006L3.26929 12.786C0.50736 15.5479 0.690692 19.5321 3.20883 22.0537C5.73379 24.5645 9.71796 24.7513 12.4799 21.9967L20.4752 14.0013C20.8715 13.6152 20.8648 12.8864 20.4576 12.5115C20.0716 12.0972 19.4208 12.1366 19.0103 12.5329Z" />
      {/if}
      {#if name === 'seat'}
        <path
          d="M5.7 16.5V19h2.5v-2.5h8.3V19H19v-5H5.7v2.5zm12.5-6.7h2.5v2.5h-2.5V9.8zM4 9.8h2.5v2.5H4V9.8zm12.5 2.5H8.2V5.7c0-1 .7-1.7 1.6-1.7h5c1 0 1.7.8 1.7 1.7v6.6z" />
      {/if}
      {#if name === 'copy'}
        <path
          d="M6.84475 3.16799C6.84475 1.10414 7.93614 0 9.98724 0H13.4495C14.5838 0 15.4675 0.300039 16.1938 1.0421L20.8117 5.74675C21.5784 6.53215 21.8508 7.35962 21.8508 8.64945V15.921C21.8508 17.9818 20.7594 19.089 18.7083 19.089H17.1582V17.0067H18.4904C19.3499 17.0067 19.7686 16.5603 19.7686 15.7413V8.19256H15.8355C14.6294 8.19256 13.9541 7.5237 13.9541 6.31118V2.08228H10.1988C9.33935 2.08228 8.92703 2.53497 8.92703 3.34769V4.90393C8.86743 4.90101 8.80643 4.89885 8.74377 4.89747C8.73973 4.89726 8.73546 4.89716 8.73109 4.89711C8.66195 4.89557 8.59096 4.89487 8.51807 4.89487H6.84475V3.16799ZM15.6162 6.07487C15.6162 6.39025 15.7501 6.5305 16.0655 6.5305H19.2271L15.6162 2.86854V6.07487Z"
          fill="currentColor" />
        <path
          d="M2.14918 20.8158C2.14918 22.8861 3.23716 23.9839 5.29166 23.9839H14.0157C16.0703 23.9839 17.1582 22.8767 17.1582 20.8158V13.7004C17.1582 12.4055 16.9852 11.7718 16.1748 10.9485L11.1713 5.87831C10.3863 5.08058 9.70508 4.89487 8.51806 4.89487H5.29166C3.24355 4.89487 2.14918 5.99263 2.14918 8.06282V20.8158ZM4.23146 20.6362V8.2362C4.23146 7.42984 4.64378 6.97714 5.50622 6.97714H8.23125V11.8622C8.23125 13.3258 8.94267 14.0279 10.3906 14.0279H15.073V20.6362C15.073 21.4552 14.6543 21.9016 13.8012 21.9016H5.49984C4.64378 21.9016 4.23146 21.4552 4.23146 20.6362ZM10.5742 12.2562C10.1794 12.2562 10.003 12.0829 10.003 11.685V7.3469L14.8456 12.2562H10.5742Z"
          fill="currentColor" />
      {/if}
      {#if name === 'train'}
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19l-1.15 1.15c-.31.31-.09.85.36.85H7.8c.13 0 .26-.05.35-.15L10 19h4l1.85 1.85c.09.09.22.15.35.15h1.09c.45 0 .67-.54.35-.85L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm5.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-7h-5V6h5v4z" />
      {/if}
      {#if name === 'pass'}
        <path
          d="M18.3 5.3v7.5l2-4.9c.3-.8 0-1.8-1-2.1l-1-.5zm-11 13.5a1.7 1.7 0 002.1 1l6.2-2.6a1.7 1.7 0 00.9-2.2L12.3 5a1.7 1.7 0 00-2.1-.9L4 6.7C3.2 7 2.8 8 3.1 8.8l4.2 10zm9.3-13.1c0-1-.8-1.7-1.7-1.7h-1.2l2.9 7V5.7z" />
      {/if}
      {#if name === 'sleep'}
        <path
          d="M10 12l-4.5 6H10v3H2v-3l4.5-6H2V9h8v3zM17.5 6.8l-2.8 3.4h2.8V12h-5v-1.8l2.8-3.4h-2.8V5h5v1.8zM23 4l-1.7 2H23v1h-3V6l1.7-2H20V3h3v1z" />
      {/if}
      {#if name === 'verified'}
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.63 22.81a3.12 3.12 0 012.74 0c1.52.74 3.34.15 4.13-1.34a3.12 3.12 0 012.22-1.61 3.12 3.12 0 002.55-3.51c-.13-.96.18-1.92.85-2.61a3.12 3.12 0 000-4.35 3.12 3.12 0 01-.85-2.6 3.12 3.12 0 00-2.55-3.52 3.12 3.12 0 01-2.22-1.61A3.12 3.12 0 0013.37.32c-.86.42-1.88.42-2.74 0A3.12 3.12 0 006.5 1.66a3.12 3.12 0 01-2.22 1.61A3.12 3.12 0 001.73 6.8c.13.95-.18 1.91-.85 2.6a3.12 3.12 0 000 4.35c.67.69.98 1.65.85 2.6a3.12 3.12 0 002.55 3.52c.95.17 1.77.76 2.22 1.61a3.12 3.12 0 004.13 1.34zM8.25 11.64l2.22 2.2 6.28-6.22a.8.8 0 011.12 0c.31.3.31.8 0 1.11l-6.83 6.79a.8.8 0 01-1.13 0l-2.79-2.77a.78.78 0 010-1.11.8.8 0 011.13 0z"
          fill="currentColor" />
      {/if}
      {#if name === 'external'}
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
      {/if}
      {#if name === 'tag'}
        <path
          d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
      {/if}
      {#if name === 'gift'}
        <path
          d="M20 5h-2.18a3 3 0 00-5.32-2.65l-.5.67-.5-.68A3 3 0 006.18 5H4c-1.11 0-1.99.89-1.99 2L2 18a2 2 0 002 2h16a2 2 0 002-2V7a2 2 0 00-2-2zm-5-2a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1zM9 3a1 1 0 011 1 1 1 0 01-1 1 1 1 0 01-1-1 1 1 0 011-1zm11 15H4v-2h16v2zm0-5H4V7h5.08L7 9.83 8.62 11 11 7.76l1-1.36 1 1.36L15.38 11 17 9.83 14.92 7H20v6z" />
      {/if}
      {#if name === 'warning'}
        <path d="M0 0h24v24H0V0z" fill="none" />
        <circle cx="12" cy="19" r="2" />
        <path
          d="M12 3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2s2-.9 2-2V5c0-1.1-.9-2-2-2z" />
      {/if}
      {#if name === 'globe'}
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
      {/if}
      {#if name === 'cart'}
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M7 18a2 2 0 100 4 2 2 0 000-4zM1 3c0 .6.5 1 1 1h1l3.6 7.6L5.2 14A2 2 0 007 17h11c.6 0 1-.5 1-1s-.5-1-1-1H7l1.1-2h7.5a2 2 0 001.7-1l3.6-6.5A1 1 0 0020 4H5.2l-.7-1.4a1 1 0 00-.9-.6H2a1 1 0 00-1 1zm16 15a2 2 0 100 4 2 2 0 000-4z" />
      {/if}
      {#if name === 'download'}
        <path
          fill="currentColor"
          d="M22.1017 9.5536V20.2936C22.1017 22.7128 20.8035 24 18.3653 24H5.63482C3.19659 24 1.89832 22.7128 1.89832 20.2936V9.5536C1.89832 7.13444 3.19659 5.8472 5.63482 5.8472H8.744V8.30316H5.83925C4.87317 8.30316 4.35427 8.79695 4.35427 9.81071V20.0365C4.35427 21.0502 4.87317 21.544 5.83925 21.544H18.1533C19.1118 21.544 19.6458 21.0502 19.6458 20.0365V9.81071C19.6458 8.79695 19.1118 8.30316 18.1533 8.30316H15.256V5.8472H18.3653C20.8035 5.8472 22.1017 7.13444 22.1017 9.5536Z" />
        <path
          fill="currentColor"
          d="M11.9963 16.9326C12.3016 16.9326 12.5802 16.8348 12.8709 16.5477L16.5565 12.9939C16.7569 12.7935 16.8702 12.5819 16.8702 12.2942C16.8702 11.7298 16.4051 11.3363 15.8758 11.3363C15.5885 11.3363 15.3224 11.4527 15.1295 11.6641L13.6706 13.2118L12.9983 14.0404L13.131 12.4071V1.11624C13.131 0.51627 12.6213 0 11.9963 0C11.3713 0 10.869 0.51627 10.869 1.11624V12.4071L11.0053 14.0404L10.322 13.2118L8.87063 11.6641C8.67765 11.4527 8.39645 11.3363 8.11677 11.3363C7.57992 11.3363 7.12982 11.7298 7.12982 12.2942C7.12982 12.5819 7.23909 12.7935 7.43608 12.9939L11.1217 16.5477C11.4234 16.8348 11.6986 16.9326 11.9963 16.9326Z" />
      {/if}

      {#if name === 'dots'}
        {@const id = Math.random().toString(36).substring(2)}
        <rect
          id="{id}-1"
          y="9"
          width="6.22222"
          height="6.22222"
          rx="3.11111"
          fill="currentColor"
          fill-opacity="0.6" />
        <rect
          id="{id}-2"
          x="8.88892"
          y="9"
          width="6.22222"
          height="6.22222"
          rx="3.11111"
          fill="currentColor"
          fill-opacity="0.6" />
        <rect
          id="{id}-3"
          x="17.7778"
          y="9"
          width="6.22222"
          height="6.22222"
          rx="3.11111"
          fill="currentColor"
          fill-opacity="0.6" />
        {#each Array(3) as _, index}
          <animate
            xlink:href="#{id}-{index + 1}"
            attributeType="CSS"
            attributeName="opacity"
            from="0.5"
            to="0.1"
            dur="800ms"
            begin="{index * 150}ms"
            repeatCount="indefinite" />
        {/each}
      {/if}

      {#if name === 'spinner'}
        {@const id = Math.random().toString(36).substring(2)}
        <path
          id="{id}-1"
          d="M12 17.1c.5 0 .9.4.9.9v5.1a.9.9 0 01-1.8 0V18c0-.5.4-.9.9-.9z" />
        <path
          id="{id}-2"
          d="M9.4 16.5c.4.2.6.7.3 1.1l-2.5 4.5a.9.9 0 11-1.5-.9l2.6-4.4c.2-.4.7-.6 1.1-.3z" />
        <path
          id="{id}-3"
          d="M7.5 14.6c.3.4.1 1-.3 1.1l-4.4 2.6a.9.9 0 01-.9-1.5l4.5-2.5c.4-.3 1-.1 1.1.3z" />
        <path id="{id}-4" d="M6 11.1A.9.9 0 016 13H.9a.9.9 0 010-1.8H6z" />
        <path
          id="{id}-5"
          d="M2.8 5.7l4.4 2.6a.9.9 0 01-.8 1.4L1.9 7.2a.9.9 0 01.9-1.5z" />
        <path
          id="{id}-6"
          d="M7.2 2l2.5 4.4a.9.9 0 01-1.4.8L5.7 2.8a.9.9 0 011.5-.9z" />
        <path
          id="{id}-7"
          d="M12 0c.5 0 .9.4.9.9V6A.9.9 0 0111 6V.9c0-.5.4-.9.9-.9z" />
        <path
          id="{id}-8"
          d="M18 1.6c.4.2.6.8.3 1.2l-2.6 4.4a.9.9 0 01-1.4-.8l2.5-4.5c.3-.4.8-.5 1.2-.3z" />
        <path
          id="{id}-9"
          d="M22.4 6c.2.4 0 1-.3 1.2l-4.5 2.5a.9.9 0 01-.8-1.4l4.4-2.6c.4-.3 1-.1 1.2.3z" />
        <path
          id="{id}-10"
          d="M23.1 11.1a.9.9 0 010 1.8H18a.9.9 0 010-1.8h5.1z" />
        <path
          id="{id}-11"
          d="M17.6 14.3l4.5 2.5a.9.9 0 11-.9 1.5l-4.4-2.6a.9.9 0 01.8-1.4z" />
        <path
          id="{id}-12"
          d="M15.7 16.8l2.6 4.4a.9.9 0 01-1.5.9l-2.5-4.5a.9.9 0 011.4-.8z" />
        {#each Array(12) as _, index}
          <animate
            xlink:href="#{id}-{index + 1}"
            attributeType="CSS"
            attributeName="opacity"
            from="1"
            to="0.1"
            dur="1100ms"
            begin="{index * 100}ms"
            repeatCount="indefinite" />
        {/each}
      {/if}
    </slot>
  </g>
</svg>

<style>
  .symbol {
    display: block;
    width: 1.375rem;
    height: 1.375rem;
    flex: 0 0 auto;
    color: var(--current-color, currentcolor);
    pointer-events: none;
  }

  .fill {
    width: 100%;
    height: 100%;
  }

  .xs {
    width: 0.875rem;
    height: 0.875rem;
  }

  .sm {
    width: 1rem;
    height: 1rem;
  }

  .md {
    width: 1.25rem;
    height: 1.25rem;
  }

  .lg {
    width: 2rem;
    height: 2rem;
  }

  .xl {
    width: 2.5rem;
    height: 2.5rem;
  }

  .xxl {
    width: 5rem;
    height: 5rem;
  }

  .adapt {
    width: 1em;
    height: 1em;
  }

  .prefix {
    display: inline-block;
    vertical-align: text-top;
    margin-right: 0.5rem;
  }

  .xs.prefix {
    margin-right: 0.3rem;
  }

  .sm.prefix {
    margin-right: 0.3rem;
  }

  .lg.prefix {
    margin-right: 0.2rem;
  }

  .xl.prefix {
    margin-right: 0.5rem;
  }

  .suffix {
    display: inline-block;
    vertical-align: text-top;
    margin-left: 0.5rem;
  }

  .sm.suffix {
    margin-left: 0.3125rem;
  }

  .lg.suffix {
    margin-left: 0.6rem;
  }

  .xl.suffix {
    margin-left: 0.75rem;
  }

  .left {
    transform: rotate(0.25turn);
    transform-origin: center;
  }

  .right {
    transform: rotate(-0.25turn);
    transform-origin: center;
  }

  .circle {
    background: var(--current-background, var(--background-alt));
    border-radius: 100%;
    border: 0.2em solid transparent;
    color: var(--current-color, rgb(var(--rgb-muted)));
    transition: var(--background-transition);
  }

  .clickthrough {
    pointer-events: none;
  }
</style>
